export const SUPPORT_EMAIL = 'contact@tapestry.ai';
